import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-2076d3bf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "special-action" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "body" }
const _hoisted_5 = { class: "content" }
const _hoisted_6 = { class: "descriptions-group" }
const _hoisted_7 = { class: "descriptions-item" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "问题描述:", -1))
const _hoisted_9 = { class: "value" }
const _hoisted_10 = { class: "descriptions-item" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "牵头部门:", -1))
const _hoisted_12 = { class: "value" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "descriptions-item" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "key" }, "所在位置:"),
  /*#__PURE__*/_createElementVNode("span", { class: "value" }, /*#__PURE__*/_toDisplayString('-'))
], -1))
const _hoisted_14 = { class: "descriptions-item" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "责任单位:", -1))
const _hoisted_16 = { class: "value" }
const _hoisted_17 = { class: "descriptions-item" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "涉及河流:", -1))
const _hoisted_19 = { class: "value" }
const _hoisted_20 = { class: "descriptions-item" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "计划完成时间:", -1))
const _hoisted_22 = { class: "value" }
const _hoisted_23 = { class: "descriptions-item" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "整改措施:", -1))
const _hoisted_25 = { class: "value" }
const _hoisted_26 = { class: "descriptions-item" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "完成情况:", -1))
const _hoisted_28 = { class: "value" }

import { toRefs, nextTick, getCurrentInstance, onMounted } from 'vue'
import { ref } from 'vue-demi'

export default /*#__PURE__*/_defineComponent({
  __name: 'SpecialAction',
  props: {
  // eslint-disable-next-line no-undef
  data: Object,
},
  setup(__props) {

const props = __props
const { data } = toRefs(props)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(data).describe || '-'), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(data).describe || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(data).leadDepartment || '-'), 1)
          ]),
          _hoisted_13,
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createElementVNode("span", _hoisted_16, _toDisplayString(_unref(data).zrxz || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _createElementVNode("span", _hoisted_19, _toDisplayString(_unref(data).hl || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_20, [
            _hoisted_21,
            _createElementVNode("span", _hoisted_22, _toDisplayString(_unref(data).planFinshTimeStr || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_23, [
            _hoisted_24,
            _createElementVNode("span", _hoisted_25, _toDisplayString(_unref(data).measure || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_26, [
            _hoisted_27,
            _createElementVNode("span", _hoisted_28, _toDisplayString(_unref(data).state || '-'), 1)
          ])
        ])
      ])
    ])
  ]))
}
}

})